import { useQuery } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";
import { WayflyerSchemas } from "api-types";

import { ENDPOINTS } from "../common/constants";

export const useCompanyMembers = (companyId: string) => {
  const fetchUrl = ENDPOINTS.GET_COMPANY_MEMBERS.replace(":companyId", companyId);
  const { get } = useAxios();

  const fetchMembers = () => get<WayflyerSchemas.CompanyMembers>(`${fetchUrl}`);
  return useQuery({
    queryKey: ["company-members", companyId],
    queryFn: fetchMembers,
    throwOnError: true,
    select: ({ data }) => data,
  });
};

export const useCompanyMember = (companyId: string, userId: string) => {
  const fetchUrl = ENDPOINTS.GET_COMPANY_MEMBER.replace(":companyId", companyId).replace(":userId", userId);
  const { get } = useAxios();

  const fetchMember = () => get<WayflyerSchemas.EditCompanyMemberSchema>(`${fetchUrl}`);
  return useQuery({
    queryKey: ["company-member", companyId, userId],
    queryFn: fetchMember,
    throwOnError: true,
    select: ({ data }) => data,
  });
};

export const useCompanyInvites = (companyId: string) => {
  const fetchUrl = ENDPOINTS.GET_COMPANY_INVITES.replace(":companyId", companyId);
  const { get } = useAxios();

  const fetchInvites = () => get<WayflyerSchemas.CompanyInvites>(`${fetchUrl}`);
  return useQuery({
    queryKey: ["company-invites", companyId],
    queryFn: fetchInvites,
    throwOnError: true,
    select: ({ data }) => data,
  });
};
